module.exports = __webpack_public_path__ + "img/single-neutral-actions-lock.0f3ed496.svg";